














import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Breadcrumbs from '@/components/TopBar/Breadcrumbs.vue';

@Component({
	components: {
		Breadcrumbs,
	},
})
export default class TopBar extends Vue {
	@Action private goTo!: any;
	@Action private restartLauncher!: any;
}
